export default __webpack_public_path__ + "static/media/Sofortig_Notification_ClickFrenzy_380x80.92bbfc7b.png";